class modalDistributionCtrl {
    constructor($scope, $uibModalInstance, items1, httpRequest, logger, distributionService) {
        $scope.input1 = items1.obj.fpsysl
        $scope.diskCode = items1.diskCode
        $scope.modalObj = items1.obj
        $scope.cancel = () => {
            $uibModalInstance.dismiss()
            // $uibModalInstance.close();
        }
        httpRequest.get_dictByTypeArr(['stock_inv_type']).then((res) => {
            $scope.dictData = res.data.value
        })
        if (items1.diskCode != 0) {
            httpRequest.post_ukeyListByDiskCodes([$scope.diskCode]).then((res) => {
                $scope.selectList = res.data.value
                $scope.selectList.forEach((element) => {
                    element.ukeyName = `${element.ukeyCode}号分机(${element.ukeyName})`
                })
            })
        } else {
            $scope.selectList = items1.diskData.filter((item) => item.diskCode != 0)
            console.log($scope.selectList)
        }
        $scope.invNumChange = function invNumChange() {
            if (+this.input1 > +$scope.modalObj.fpsysl) {
                logger.logError('超过最大可分配数量！')
                this.input1 = ''
            }

            $scope.input1 = this.input1
        }
        $scope.modalDistriSubmit = function modalDistriSubmit() {
            if (+$scope.input1 < 1 || !+$scope.input1 || ~~+$scope.input1 != +$scope.input1) {
                logger.logError('分配发票数量不合法')
                $scope.input1 = ''
                return
            }
            if (!$scope.select1) {
                if ($scope.diskCode != 0) {
                    logger.logError('开票点为空！请选择分配对象')
                    return
                }
                logger.logError('分机号为空！请选择分配对象')
                return
            }
            if ($scope.diskCode == 0) {
                const param = IS_NO_KEY ? {
                    clientNo: $scope.select1.diskCode === '0' ? $scope.select1.diskCode : $scope.modalObj.zdh,
                    fjh: $scope.select1.diskCode,
                    invoiceCount: $scope.input1,
                    invoiceNumber: $scope.modalObj.fphm,
                    invoiceType: $scope.modalObj.fpzl,
                    serverDiskCode: items1.diskCode,
                    typeCode: $scope.modalObj.lbdm,
                } : {
                    diskCode: $scope.select1.diskCode,
                    invType: $scope.modalObj.fpzl,
                    typeCode: $scope.modalObj.fpdm,
                    startNumber: $scope.modalObj.fphm,
                    invNumber: $scope.input1,
                }
                distributionService.queryDistribution(param).then(() => { // 无key跳过addAllotOperateRecord
                    !IS_NO_KEY && addAllotOperateRecord()
                    IS_NO_KEY && $uibModalInstance.close() && logger.logSuccess('发票分配成功！')
                }, (err) => {
                    err ? logger.logError(err) : logger.logError('发票分配失败，请稍后再试！')
                })
            } else {
                const reqObj = IS_NO_KEY ? {
                    clientNo: $scope.select1.ukeyCode,
                    invoiceCount: $scope.input1,
                    invoiceNumber: $scope.modalObj.fphm,
                    invoiceType: $scope.modalObj.fpzl,
                    serverDiskCode: items1.diskCode,
                    typeCode: $scope.modalObj.lbdm,
                } : {
                    clientNo: $scope.select1.ukeyCode,
                    invoiceCount: $scope.input1,
                    invoiceNumber: $scope.modalObj.fphm,
                    invoiceType: $scope.modalObj.fpzl,
                    serverDiskCode: $scope.diskCode,
                    typeCode: $scope.modalObj.fpdm,
                }
                distributionService.post_allotServerDiskInvoice2Ukey(reqObj).then((res) => {
                    !IS_NO_KEY && addAllotOperateRecord()
                    IS_NO_KEY && $uibModalInstance.close() && logger.logSuccess('发票分配成功！')
                }, (err) => {
                    err ? logger.logError(err) : logger.logError('发票分配失败，请稍后再试！')
                })
            }
            function addAllotOperateRecord() {
                const pointType = $scope.diskCode == 0 ? 1 : 2
                httpRequest.post_addAllotOperateRecord({
                    allotOrgId: JSON.parse(localStorage.user_info).org.orgId,
                    devisionPointCode: $scope.diskCode,
                    devisionType: 1,
                    invoiceCount: $scope.input1,
                    invoiceNumberStart: $scope.modalObj.fphm,
                    invoiceType: $scope.modalObj.fpzl,
                    invoiceTypeCode: $scope.modalObj.fpdm,
                    receivePointCode: $scope.select1.ukeyCode || $scope.select1.diskCode,
                    receivePointType: pointType,
                }).then((res) => {
                    if (res.data.msgCode == 0) {
                        logger.logSuccess('发票分配成功！')
                        $uibModalInstance.close()
                    } else {
                        logger.logError('发票分配失败，请稍后再试！')
                    }
                })
            }
        }
        $scope.selectChange = function selectChange() {
            $scope.select1 = this.select1
        }
    }
}

modalDistributionCtrl.$inject = ['$scope', '$uibModalInstance', 'items1', 'httpRequest', 'logger', 'distributionService']
export default modalDistributionCtrl



// WEBPACK FOOTER //
// ./src/app/outputManage/stock/distribution/modalDistributionCtrl.js